import { render, staticRenderFns } from "./InstrumentAbout.vue?vue&type=template&id=35459718&scoped=true"
import script from "./InstrumentAbout.vue?vue&type=script&lang=ts"
export * from "./InstrumentAbout.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentAbout.vue?vue&type=style&index=0&id=35459718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35459718",
  null
  
)

export default component.exports